import _isEmpty from "lodash/isEmpty";
import _get from "lodash/get";
import momentTimezone from "moment-timezone";
import browser from "browser-detect";

export function getUtmTags(query) {
    const utmTags = {};
    Object.entries(query).forEach(queryParam => {
        const [key, value] = queryParam;
        if (key.includes("utm")) {
            utmTags[key] = value;
        }
    });
    return utmTags;
}

export function getUserProperties(eventProperties = {}, userData = {}) {
    const browserData = browser();
    const customEventProps = {
        ...eventProperties,
        context_locale: window.navigator.language,
        context_timezone: momentTimezone.tz.guess(),
        os: browserData.os,
        browser: browserData.name,
        browser_version: `${browserData.name} ${browserData.version}`,
        mobile_browser: browserData.mobile
    };

    if (!_isEmpty(userData)) {
        customEventProps["created_at"] = userData.settings && userData.settings.created_on;
        customEventProps["name"] =
            _get(userData, "user.first_name", "") ||
            _get(userData, "facebook.first_name", "") ||
            _get(userData, "first_name", "");
        customEventProps["email"] =
            _get(userData, "user.email_address", "") ||
            _get(userData, "facebook.email_address", "") ||
            _get(userData, "email", "");
        customEventProps["created_at"] = userData.settings && userData.settings.created_on;
        customEventProps["created_at"] = userData.settings && userData.settings.created_on;
        _get;
        if (!_isEmpty(userData.facebook)) {
            customEventProps["facebook_id"] = userData.facebook.facebook_id;
        }
    }
    return customEventProps;
}
